// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-event.styled.classic.js, новая — rack-event.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-event.styled.classic';
import * as cp from './rack-event.styled.cp';

export const Badge = isCp ? cp.Badge : undefined;
export const Content = isCp ? cp.Content : classic.Content;
export const Icon = isCp ? undefined : classic.Icon;
